import { Id, Snakify } from "PFTypes";

import { getAttribute } from "./get_attribute";

type ItemWithId = Snakify<{
  id?: Id | null;
  globalId?: Id | null;
}>;

// eslint-disable-next-line camelcase
export const getId = (itemWithId: ItemWithId): Id =>
  itemWithId.id ?? getAttribute(itemWithId, "globalId") ?? "";
